import { render, staticRenderFns } from "./dealData.vue?vue&type=template&id=5ed87bd4&scoped=true"
import script from "./dealData.vue?vue&type=script&lang=js"
export * from "./dealData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed87bd4",
  null
  
)

export default component.exports